import { render, staticRenderFns } from "./DiscountedAmount.vue?vue&type=template&id=32110e0e&"
import script from "./DiscountedAmount.vue?vue&type=script&lang=js&"
export * from "./DiscountedAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports